
export let preorderMixin = {
	data() {
		return {
			bullet: {
				deliveryDay: 0,
				items: []
			},
			changeDeliveryTime: false
		}
	},
	computed: {
		preOrderProductList()
		{
			if(
				!this.bullet.items
				|| this.bullet.items.length <= 0
			) {
				return [];
			}

			return this.result.PREPARED_ITEMS.filter(
				(product) => this.bullet.items.includes(Number.parseInt(product.product_id))
			);
		},
		needPreOrderValidation()
		{
			if(
				!this.bullet.items
				|| this.bullet.items.length <= 0
				|| this.preOrderProductList.length <= 0
				|| !this.bullet.needValidation
			) {
				return false;
			}

			return true;
		}
	},
	methods: {
		/** Инициализация. Собирает текущие данные для предзаказа */
		__initPreOrderData()
		{

			this.bullet = {
				needValidation: false,
				deliveryDay: false,
				items: false,
			}

			let result = this.result;
			let bullets = result.hasOwnProperty('BULLETS') ? result.BULLETS : [];

			if(
				bullets.length <= 0
				|| !bullets.NEED_VALIDATION
			) {
				this.setVisiblePopup("PopupBullets", false);

				return;
			}

			this.bullet = {
				needValidation: bullets.NEED_VALIDATION,
				deliveryDay: bullets.DELIVERY_DAYS,
				items: bullets.ITEMS,
			}

			if(this.changeDeliveryTime)
			{
				this.checkPreOrderValidation();
				this.changeDeliveryTime = false;
			}
		},
		onChangeDeliveryTime()
		{
			this.changeDeliveryTime = true;
		},
		checkPreOrderValidation()
		{
			if(!this.needPreOrderValidation)
				return;

			this.showPreOrderValidation();
		},
		showPreOrderValidation()
		{
			this.setVisiblePopup("PopupBullets", true, {
				productList: this.preOrderProductList,
				deliveryDays: this.bullet ? this.bullet.deliveryDay : false,
			});
		}
	}
}

export default preorderMixin;